import React, { 
  // useRef, 
  // useState 
} from "react";
import { 
  // SearchOutlined 
} from "@ant-design/icons";
// import Highlighter from "react-highlight-words";
import { 
  // Button, 
  // Input, 
  // Space, 
  Table, 
  Tag 
} from "antd";
import { useNavigate } from "react-router-dom";
import { ProductOutlined } from '@ant-design/icons';

const AntDTable = ({
    tableHeaders,
    headerSelector,
    tableData,
    rowClickPath,
    isClickable,
    ActionBtn,
    withAction,
    loading,
    customFooter,
    className,
    searchExcluded = [], // headers to exclude from search feature
    pageSize,
    handleTableChange,
    filterConfig,
    totalSize,
    isSearch,
  }) => {
    const navigate = useNavigate();
    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />; // Custom spinner component
    const handleRowClick = (record) => {
      if (isClickable) {
        const id = record.id;
        navigate(`${rowClickPath}/${id}`);
      }
    };
    
    const columns = tableHeaders.map((header, index) => {
      let column = {
        title: header,
        dataIndex: headerSelector[index],
        key: headerSelector[index],
        align: 'center',
        sorter: (a, b) => {
          const valueA = a[headerSelector[index]];
          const valueB = b[headerSelector[index]];

          if (typeof valueA === "string" && typeof valueB === "string") {
            return valueA.localeCompare(valueB, undefined, { sensitivity: "base" });
          } else if (typeof valueA === "number" && typeof valueB === "number") {
            return valueA - valueB;
          } else if (valueA instanceof Date && valueB instanceof Date) {
            return valueA - valueB;
          } else {
            // One value is a string and the other is a number or date, prioritize string sorting
            return typeof valueA === "string" ? -1 : 1;
          }
        },
        sortDirections: ["descend", "ascend"],
      };
      
      // Right Align and their headers
      if (
        header === 'Management Fee' ||
        header === 'Agent Fee' ||
        header === 'VAT' ||
        header === 'Withholding Tax' ||
        header === 'Total' ||
        header === 'Fixed Price' ||
        header === 'Percentage' ||
        header === 'Amount' ||
        header === 'Balance' ||
        header === 'Paid Amount' ||
        header === 'Unit Rent' ||
        header === 'Parking Rent' ||
        header === 'Cusa' ||
        header === 'Electricity' ||
        header === 'Gas' ||
        header === 'Water' ||
        header === 'Others' ||
        header === 'Sec Deposit' ||
        header === 'Current' ||
        header === '1-30' ||
        header === '31-60' ||
        header === '61-90' ||
        header === 'Above 90' ||
        header === 'Income Amount' ||
        header === 'Expense Amount' ||
        header === 'Total Net Income' ||
        header === 'Unit Price'
      ) {
        column.render = (digits) => {
          return (
            digits && <div align='right'>{digits}</div>
          );
        };
      }

      if (header === 'Property Type') {
        column.render = (property_type) => {
          let color = '';
          let name = ''
    
          if (property_type === "commercial_building") {
            color = 'gold';
            name = 'Commercial';
          } else if (property_type === "raw_lot") {
            color = 'blue';
            name = 'Raw Lot';
          } else if (property_type === "residential_building") {
            color = 'purple';
            name = 'Residential';
          }
    
          return (
            property_type && <Tag color={color}>{name.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Task Status') {
        column.render = (status) => {
          let color = '';
          let name = ''
    
          if (status === "in-progress") {
            color = 'gold';
            name = 'In-Progress';
          } else if (status === "to do") {
            color = 'blue';
            name = 'To Do';
          } else if (status === "cancelled") {
            color = 'red';
            name = 'Cancelled';
          } else if (status === "done") {
            color = 'green';
            name = 'Done';
          }
    
          return (
            status && <Tag color={color}>{name.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Priority') {
        column.render = (priority) => {
          let color = '';
          let name = ''
    
          if (priority === "high") {
            color = 'red';
            name = 'High';
          } else if (priority === "medium") {
            color = 'orange';
            name = 'Medium';
          } else if (priority === "low") {
            color = 'green';
            name = 'Low';
          }
    
          return (
            priority && <Tag color={color}>{name.toUpperCase()}</Tag>
          );
        };
      }
      
      if (header === 'Payment Status') {
        column.render = (payment_status) => {
          let color = 'red';
          let name = 'null'
    
          if (payment_status === "bounced") {
            color = 'orange';
            name = 'Bounced';
          } else if (payment_status === "for_approval") {
            color = 'blue';
            name = 'For Approval';
          } else if (payment_status === "cleared") {
            color = 'green';
            name = 'Cleared';
          } else if (payment_status === "voided") {
            color = 'red';
            name = 'Voided';
          }
    
          return (
            <Tag color={color}>{name.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Furnishing') {
        column.render = (furnishing) => {
          let name = ''
    
          if (furnishing === "fully") {
            name = 'Fully Furnished';
          } else if (furnishing === "semi") {
            name = 'Semi Furnished';
          } else if (furnishing === "unfurnished") {
            name = 'Unfurnished';
          }
    
          return (
            <div>{name}</div>
          );
        };
      }

      if (header === 'Payment Type') {
        column.render = (payment_type) => {
          let color = 'red';
          let name = 'null'
    
          if (payment_type === "cash") {
            color = 'green';
            name = 'Cash';
          } else if (payment_type === "check") {
            color = 'blue';
            name = 'Check';
          } else if (payment_type === "other") {
            color = 'orange';
            name = 'Other';
          }
    
          return (
            <Tag color={color}>{name.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Manage') {
        column.render = (is_managed) => {
          let name = ''
    
          if (is_managed === "1") {
            name = 'Managed';
          } else if (is_managed === "0") {
            name = 'Not Managed';
          }
    
          return (
            <div>{name}</div>
          );
        };
      }

      if (header === 'Status') {
        column.render = (status) => {
          let color = 'red';
    
          if(status === "occupied" || status === "pending" || status === "ongoing" || status === "due"){
              color = 'red'
          } else if(status === "vacant" || status === "active" || status === "paid" || status === "completed"){
              color = 'green'
          } else if(status === "for renewal"  || status === "closed"){
              color = 'blue'
          } else if(status === "moved out"){
              color = 'black'
          } else if(status === "pre-terminated"){
              color = 'orange'
          } else if(status === "voided"){
              color = 'grey'
          } else if(status === "open"){
              color = 'yellow'
          }
    
          return (
            <Tag color={color}>{status.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Reading Status') {
        column.render = (status) => {
          let color = 'red';
    
          if(status === "ongoing"){
              color = 'red'
          } else if(status === "paid"){
              color = 'green'
          } 
    
          return (
            <Tag color={color}>{status.toUpperCase()}</Tag>
          );
        };
      }

      if (header === 'Type') {
        column.render = (type) => {
          let color = 'red';
    
          if(type === "tenant"|| type === "tenant_parking"){
              color = 'gold'
          } else if(type === "owner"){
              color = 'green'
          } else if(type.toLowerCase() === "parking unit" || type.toLowerCase() === "rental"){
              color = 'orange'
          } else if(type.toLowerCase() === "rental unit" ||  type.toLowerCase() === "parking"){
              color = 'blue'
          } else if(type === "internal"){
              color = 'silver'
          }
    
          return (
            <Tag color={color}>{type?.toUpperCase()}</Tag>
          );
        };
      }
    
      return column;
    });
      
    if (withAction) {
      columns.push({
        // title: "ACTION",
        key: "action",
        width: 100,
        // color: "var(--sidebar-color)",
        render: (_, record) => <ActionBtn row={record} />,
      });
    }

    const pageSizeOptions = ['10', '20', '50', '100', `${totalSize}`];
    const sortedPageSizeOptions = pageSizeOptions.filter(item => item <= totalSize).sort((a, b) => Number(a) - Number(b));
  
    return (
      <Table
        columns={columns}
        dataSource={tableData}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        loading={{
          indicator: customSpinner, // Use custom spinner
          spinning: loading, // Set spinning based on loading state
        }}
        footer={customFooter}
        size="middle"
        className="table-bg"
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: sortedPageSizeOptions,
          showSizeChanger: true,
          total: totalSize,
          current: filterConfig?.page,
          pageSize: filterConfig?.total_records_per_page,
        }}
        onChange={handleTableChange}
      />
    );
  };
  
  export default AntDTable;